import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./style.scss";
import Banner from "../../assets/images/he21-banner.png";
import { arrowDown, arrowUp } from '../../assets/images/svg';

import HE211 from '../../assets/images/why-he21-1.png';
import HE212 from '../../assets/images/why-he21-2.png';
import HE213 from '../../assets/images/why-he21-3.png';
import HE214 from '../../assets/images/why-he21-4.png';

import He21PartnerTestimonial from '../../assets/images/he21_partner_Testimonial.png';
import He21StudentTestimonial from '../../assets/images/he21_student_Testimonial.png';
import He21TeacherTestimonial from '../../assets/images/he21_teacher_Testimonial.png';

import SpecilisationBorder from '../../assets/images/specilisation-border.png';
import SpecilisationBorder5 from '../../assets/images/specilisation-border-5.png';
import CareerPathways from '../../assets/images/career_pathways_he21.png';

import IITDelhiLogo from '../../assets/images/IIT_Delhi_logo.png';
import NIFTLogo from '../../assets/images/NIFT_logo.png';
import CampK12Logo from '../../assets/images/Camp_K12.png';
import LAHILogo from '../../assets/images/LAHI_logo.png';

import GalleryImg1 from '../../assets/images/he21-gallery-1.jpg';
import GalleryImg2 from '../../assets/images/he21-gallery-2.jpg';
import GalleryImg3 from '../../assets/images/he21-gallery-3.jpg';
import GalleryImg4 from '../../assets/images/he21-gallery-4.jpg';
import GalleryImg5 from '../../assets/images/he21-gallery-5.jpg';

import Breadcrum from '../../common/Breadcrum';
import SchoolGallery from "../../common/Gallery";
import { LanguageContext } from "../../App";
import { lang } from "../../language";

const HE21 = () => {
  const language= React.useContext(LanguageContext)

  const [showCurriculum, setShowCurriculum] = useState(false);
  const [showCreators, setShowCreators] = useState(false);
  const [showCareerPathways,setCareerPathways]=useState(false);
  const [showAchievements, setAchievements]=useState(false);

  return (
    <div className="specialization">
      <Breadcrum name={"High-End 21st Century Skills"} path="/specialisation/he21" />
      <div className="banner">
        <img src={Banner} alt="DBSE SOSE" title="DBSE SOSE" />

        <div className="inner-breadcrum-container">
          <div className="inner-breadcrum" dangerouslySetInnerHTML={{ __html: lang[language].he21.inner }}></div>
          <div className="inner-breadcrum-hover" dangerouslySetInnerHTML={{ __html: lang[language].he21.breadcrumHover }}></div>
        </div>
      </div>
      <div className="specialization-description" dangerouslySetInnerHTML={{ __html: lang[language].he21.specializationdescription }}></div>
      <div className="specialization-section">
        <div className="specialization-content">
          <div className='why afps'>
            <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.title }}></div>
            <div className='cards' >
              <div className="why-card">
                <img src={HE211} alt="DBSE SOSE" className="why-icon" />
                <div className="content">
                  <img src={SpecilisationBorder} alt="" />
                  <div dangerouslySetInnerHTML={{ __html: lang[language].he21.Card1 }}></div>
                </div>
              </div>
              <div className="why-card">
                <img src={HE212} alt="DBSE SOSE" className="why-icon" />
                <div className="content">
                  <img src={SpecilisationBorder5} alt="" />
                  <div dangerouslySetInnerHTML={{ __html: lang[language].he21.Card2 }}></div>
                </div>
              </div>
              <div className="why-card">
                <img src={HE213} alt="DBSE SOSE" className="why-icon" />
                <div className="content">
                  <img src={SpecilisationBorder} alt="" />
                  <div dangerouslySetInnerHTML={{ __html: lang[language].he21.Card3 }}></div>
                </div>
              </div>
              <div className="why-card">
                <img src={HE214} alt="DBSE SOSE" className="why-icon" />
                <div className="content">
                  <img src={SpecilisationBorder} alt="" />
                  <div dangerouslySetInnerHTML={{ __html: lang[language].he21.Card4 }}></div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordian currriculum">
            <div
              className="outer"
              onClick={() => setShowCurriculum(!showCurriculum)}
            >
              {/* <div className="title">Curriculum {showCurriculum && <br />} <span>Design</span></div> */}
              {showCurriculum ? (
                                <div className='title' dangerouslySetInnerHTML={{ __html: lang[language].afps.title2 }}></div>    
                            ): (
                                <div className='title' dangerouslySetInnerHTML={{ __html: lang[language].afps.title2Closed }}></div>
                            )}
              <div className="icon">{showCurriculum ? arrowUp : arrowDown}</div>
            </div>

            {showCurriculum && (
              <div className="inner">
                <div className="currriculum_design">
                  <div className="currriculum_grade_section">
                    <div className="heading">
                      <div className="horizontal-border"></div>
                      <div className="grade" dangerouslySetInnerHTML={{ __html: lang[language].he21.grade }}></div>
                      <div className="horizontal-border"></div>
                    </div>

                    <div className="currriculum_subjects">
                      <div className="currriculum_container">
                        <div className="currriculum_heading left" dangerouslySetInnerHTML={{ __html: lang[language].he21.currriculum_heading_right }}>
                        </div>
                      </div>
                      <div className="currriculum_container">
                        <div className="currriculum_heading right" dangerouslySetInnerHTML={{ __html: lang[language].he21.currriculum_heading_left }}>
                        </div>
                      </div>
                    </div>

                    <div className="currriculum_subjects">
                      <div className="currriculum_container">
                        <div className="currriculum_description left">
                        <div className="paragraph">
                            <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.title3 }}></div>
                            <div className="sub-title" dangerouslySetInnerHTML={{ __html: lang[language].he21.sub_title1 }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.desc1 }}></div>
                            <div className="sub-title" dangerouslySetInnerHTML={{ __html: lang[language].he21.sub_title2 }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.desc2 }}></div>
                            <div className="sub-title" dangerouslySetInnerHTML={{ __html: lang[language].he21.sub_title3 }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.desc3 }}></div></div>
                          <div className="paragraph">
                            <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.title4 }}></div>
                            <div className="sub-title" dangerouslySetInnerHTML={{ __html: lang[language].he21.sub_title4a }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.desc4a }}></div>
                            <div className="sub-title" dangerouslySetInnerHTML={{ __html: lang[language].he21.sub_title4b }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.desc4b }}></div>
                            <div className="sub-title" dangerouslySetInnerHTML={{ __html: lang[language].he21.sub_title4c }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.desc4c }}></div>
                          </div>
                        </div>
                      </div>
                      <div className="currriculum_container">
                        <div className="currriculum_description right">
                        <ul>
                            <li dangerouslySetInnerHTML={{ __html: lang[language].he21.Mathematics }}></li>
                            <li dangerouslySetInnerHTML={{ __html: lang[language].he21.English }}></li>
                            <li dangerouslySetInnerHTML={{ __html: lang[language].he21.Hindi }}></li>
                            <li dangerouslySetInnerHTML={{ __html: lang[language].he21.Science }}></li>
                            <li dangerouslySetInnerHTML={{ __html: lang[language].he21.IndividualSocieties }}></li>
                            <li dangerouslySetInnerHTML={{ __html: lang[language].he21.Entrepreneurial }}></li>
                          </ul>

                       
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div className="heading">
                    
                      <div className="horizontal-border"></div>
                      <div className="currriculum_heading left" dangerouslySetInnerHTML={{ __html: lang[language].he21.subtilteSC }}></div>
                      <div className="horizontal-border"></div>
                    </div>
                    <div className="elegibility_criteria_section2">

                      <div className="elegibility_criteria_container3">
                        <div className="elegibility_criteria_container4">
                          <p>
                            <b>2A. Advanced Technologies</b><br/>
                            <p>
                           <b> a. Coding </b><br/>
                            <p>
                            The course covers the fundamentals of app development, web development, and game development so that students can work on real-world and industry-relevant projects. The focus is to build problem-solving, logical and algorithmic skills in the students.  
                            </p>
 
                            </p>
                          <p>
                          <b> b. Robotics and Automation </b><br/>
                          <p>Students learn about the main building blocks of robotics systems and their functioning. The course will comprise of understanding the concepts of robotics, drones, Artificial Intelligence (AI), automation and smart manufacturing, and programming techniques to make robotic systems work.</p>
                          </p>
                          <p>
                            <b>c. Electro-mechanical Production</b>
                            <p>EMP targets building the concepts and skills which are relevant to the fields of electrical and mechanical. Students learn about modern machines and how their different sub-components (micro-controllers, sensors, etc) come together to make machines work.</p>
                          </p>
                          <br/>
                          </p>
                          <p>
                            <b>2B.  Design and Commerce</b><br/>
                            <p>
                            <b>a. Fashion Design and Aesthetics</b>
                            <p>The course aims to teach theoretical and practical aspects of fashion and textiles through hands-on learning viz block printing, dyeing, etc. The course covers the key components of fashion design - from traditional to contemporary so that students develop an understanding of user needs and contexts and develop aesthetic and design sensibilities.</p>
                            </p>
                            <p>
                            <b>b. Digital Media and Design</b>
                           <p>Students learn design techniques and  venture into domains such as graphics, animation, and UI/UX. They are taught to understand design as an approach to solving problems, delve into the design process and connect it with people, enterprises and communities. </p>
                            </p>
                            <p>
                              <b>c. Finance and Accounting</b>
                              <p>This course aims to bring the modern concepts of finance and accounting inside the classroom. It covers the aspects of budgeting, banking, financial markets, and fin-tech, and exposes students to real-world applications of finance and accounting.</p>
                            </p>


                          </p>

                         </div>
                        <div className="border"></div>
                      </div>
                    
                    </div>

                  </div>

                  <div className="currriculum_grade_section section_change">
                    <div className="heading">
                      <div className="horizontal-border"></div>
                      <div className="grade" dangerouslySetInnerHTML={{ __html: lang[language].he21.grade11_12 }}></div>
                      <div className="horizontal-border"></div>
                    </div>

                    <div className="currriculum_subjects">
                      <div className="currriculum_container">
                        <div className="currriculum_heading left" dangerouslySetInnerHTML={{ __html: lang[language].he21.Specialised_Subjects }}>
                        </div>
                      </div>
                      <div className="currriculum_container">
                        <div className="currriculum_heading right" dangerouslySetInnerHTML={{ __html: lang[language].he21.Foundational_Subjects }}></div>
                      </div>
                    </div>
                    <div className="currriculum_subjects">
                      <div className="currriculum_container">
                        <div className="currriculum_description left">
                        <div className="paragraph">
                        <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.currriculum_container.title }}></div>
                            <div className="desc">a. Full Stack Web Development</div>
                            <div className="desc">b. Data Science: Python, AI and ML</div>
                          <br/>
                        </div>
                        <div className="paragraph">
                            <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph1.title }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph1.desc1 }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph1.desc2 }}></div>
                            <br/>
                        </div>
                        
                        <div className="paragraph">
                            <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph5.title }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph5.desc1 }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph5.desc2 }}></div>
                          </div>

                        </div>
                      </div>
                      <div className="currriculum_container">
                        <div className="currriculum_description right">
                          <div className="paragraph">
                            <div className="desc">1. English</div>
                            <div className="desc">2. Physics</div>
                            <div className="desc">3. Chemistry</div>
                            <div className="desc">4. Mathematics</div>
                           </div>
                         
                        
                        </div>
                      </div>

                      
                    </div>
                    
                
                    

                  </div>

                  <div className="currriculum_grade_section section_change">
        
                    <div className="currriculum_subjects">
                      <div className="currriculum_container">
                        <div className="currriculum_description left">
                        <div className="paragraph">
                        <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph4.title }}></div>
                        <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph4.desc1 }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph4.desc2 }}></div>
                           
                          <br/>
                        </div>
                        <div className="paragraph">
                            <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph2.title }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph2.desc1 }}></div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph2.desc2 }}></div>
                            <br/>
                        </div>
                        
                      

                        </div>
                      </div>
                      <div className="currriculum_container">
                        <div className="currriculum_description right">
                          <div className="paragraph">
                            <div className="desc">1. English</div>
                            <div className="desc">2. Mathematics and Statistics</div>
                            <div className="desc">3. Business Studies</div>
                            <div className="desc">4. Economics</div>
                           </div>
                         
                        
                        </div>
                      </div>

                      
                    </div>
                    
                
                    

                  </div>

                  <div className="currriculum_grade_section section_change">
        
        <div className="currriculum_subjects">
          <div className="currriculum_container">
            <div className="currriculum_description left">
            <div className="paragraph">
            <div className="title" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph3.title }}></div>
            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph3.desc0 }}></div>
            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph3.desc2 }}></div>
            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph3.desc3 }}></div>
            <div className="desc" dangerouslySetInnerHTML={{ __html: lang[language].he21.paragraph3.desc1 }}></div>
              <br/>
            </div>
        
            </div>
          </div>
          <div className="currriculum_container">
            <div className="currriculum_description right">
              <div className="paragraph">
                <div className="desc">1. English</div>
                <div className="desc">2. Pick any 1: <br/>&nbsp;&nbsp;a. Mathematics and Statistics<br/>&nbsp;&nbsp;b. Humanities (Geography/Political Science/History)</div>
                <div className="desc">3. Business Studies</div>
             
               </div>
             
            
            </div>
          </div>

          
        </div>
        
    
        

      </div>

                </div>
              </div>
            )}
          </div>
        

          <div className='horizontal'></div>
                    <div className='accordian currriculum'>
                        <div className='outer' onClick={() => setCareerPathways(!showCareerPathways)}>
                            <div className='title'>Higher education {showCareerPathways && <br />} <span> and career pathways</span></div>
                            <div className='icon'>{showCareerPathways ? arrowUp : arrowDown}</div>
                        </div>
                        {showCareerPathways && (

                            <div className='inner'>
                                <div className='currriculum_design'>
                                    <div className='currriculum_grade_section'>
                                        <div className='heading'>
                                        <div className='horizontal-border'></div>
                                            <div className='grade'>Coding</div>
                                            <div className='horizontal-border'></div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading left'>Suggested Higher Education Pathways</div>
                                            </div>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading right'>Potential Career Pathways</div>
                                            </div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description right'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                              <li>B.E. (Computer Science)</li>
                                              <li>Diploma in Computer Programming</li>
                                              <li>B.Sc. (Computer Application)</li>
                                              <li>B.C.A. (Computer Application)</li>
                                              </ol>
                                            </div>
                                            </div>
                                        </div>
                                              
                                            </div>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description left'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                              <li>Front-end developer</li>
                                              <li>Back-end developer</li>
                                              <li>Data Scientist</li>
                                              </ol>
                                              </div>
                                            </div>
                                         </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>


                                    <div className='currriculum_grade_section'>
                                        <div className='heading'>
                                        <div className='horizontal-border'></div>
                                            <div className='grade'>Digital Media and Design</div>
                                            <div className='horizontal-border'></div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading left'>Suggested Higher Education Pathways</div>
                                            </div>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading right'>Potential Career Pathways</div>
                                            </div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description right'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                                <li>Bachelor in Product Design</li>
                                                <li>Animation, Multimedia and VFX</li>
                                                <li>B. Des. in Graphic Designing</li>
                                                </ol>
                                                  </div>
                                            </div>
                                        </div>
                                              
                                            </div>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description left'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                                  <li>Graphics/Communication designer </li>
                                                  <li>Illustrator</li>
                                                  <li>UI/ UX Design</li>
                                                  <li>Animator</li>
                                                  </ol>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>

                                    <div className='currriculum_grade_section'>
                                        <div className='heading'>
                                        <div className='horizontal-border'></div>
                                            <div className='grade'>Robotics & Automation</div>
                                            <div className='horizontal-border'></div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading left'>Suggested Higher Education Pathways</div>
                                            </div>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading right'>Potential Career Pathways</div>
                                            </div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description right'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                              <li>Diploma/ Graduate degree in Engineering</li>
                                              <li>B. Tech Robotics and Automation</li>
                                              <li>M. Tech Robotics and Automation</li>
                                              </ol>

                                            </div>
                                            </div>
                                        </div>
                                              
                                            </div>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description left'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                                <li>Manufacturing</li>
                                                <li>Research and Development</li>
                                                <li>Quality control</li>
                                                </ol>
                                                </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                                    <div className='currriculum_grade_section'>
                                        <div className='heading'>
                                        <div className='horizontal-border'></div>
                                            <div className='grade'>Finance & Accounting</div>
                                            <div className='horizontal-border'></div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading left'>Suggested Higher Education Pathways</div>
                                            </div>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading right'>Potential Career Pathways</div>
                                            </div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description right'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                                <li>Professional Courses in Chartered Accountancy, Chartered Financial Analyst</li>
                                                <li>Financial Risk Management</li>
                                                <li>Bachelor in Commerce</li>
                                                <li>Bachelor in Business Administration</li>
                                                <li>B.Sc. Finance</li>
                                            </ol>

                                            </div>
                                            </div>
                                        </div>
                                              
                                            </div>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description left'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                                <li>Investment Banker</li>
                                                <li>Chartered Accountant</li>
                                                <li>Stock Analyst</li>
                                                <li>Tax Consultant</li>
                                                </ol>
                                           
                                                </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>

                                    <div className='currriculum_grade_section'>
                                        <div className='heading'>
                                        <div className='horizontal-border'></div>
                                            <div className='grade'>Fashion Design & Aesthetics</div>
                                            <div className='horizontal-border'></div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading left'>Suggested Higher Education Pathways</div>
                                            </div>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading right'>Potential Career Pathways</div>
                                            </div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description right'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                              <li>B.Sc. Fashion Design</li>
                                              <li>B. Design</li>
                                              <li>B. Tech in Fashion Design</li>
                                              <li>MBA Fashion Design/ Management</li>
                                              </ol>
                                            </div>
                                            </div>
                                        </div>
                                              
                                            </div>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description left'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                              <li>Costume Designer</li>
                                              <li>Fashion Stylist</li>
                                              <li>Public Relations and Luxury Brand Management</li>
                                              </ol>
                                                                                        
                                                </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>

                                    <div className='currriculum_grade_section'>
                                        <div className='heading'>
                                        <div className='horizontal-border'></div>
                                            <div className='grade'>Electromechanical Production</div>
                                            <div className='horizontal-border'></div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading left'>Suggested Higher Education Pathways</div>
                                            </div>
                                            <div className='currriculum_container'>
                                                <div className='currriculum_heading right'>Potential Career Pathways</div>
                                            </div>
                                        </div>

                                        <div className='currriculum_subjects'>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description right'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                                  <li>Diploma courses in PLC and Automation and Industrial Robotics</li>
                                                  <li>B.Tech - Mechatronics, Electronics and Communication, M.Tech - Mechanical, Industrial Engineering & Operations Research, Materials, Manufacturing and Modeling, Systems & Control Engineering</li>
                                                  </ol>

                                            </div>
                                            </div>
                                        </div>
                                              
                                            </div>
                                            <div className='currriculum_container'>
                                            <div className='currriculum_description left'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <ol>
                                              <li>- PLC Design Engineer</li>
                                              <li>- Automation Engineer</li>
                                              <li>- Quality assurance technicians.</li>
                                              <li>- Robot design engineers.</li>
                                              <li>- Robotics test engineers.</li>
                                              </ol>
                                           
                                                </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>

                                </div>
                                <br/>
                            </div>
                           
                        )}


                    </div>

                
                    <div className='horizontal'></div>
                    <div className='accordian currriculum'>
                        <div className='outer' onClick={() => setAchievements(!showAchievements)}>
                            <div className='title'>Achievements {showAchievements} </div>
                            <div className='icon'>{showAchievements ? arrowUp : arrowDown}</div>
                        </div>
                        {showAchievements && (

                            <div className='inner'>
                                <div className='currriculum_design'>
                                <div className='currriculum_grade_section section_change'>
                                        <div className='currriculum_container'>
                                            <div className='currriculum_description all'>
                                            <div className='paragraph'>
                                            <div class='desc'>
                                            <p>
                                                1. <b>Delhi Robotics League (DRL)</b> has been conceptualised as a flagship event for HE21 ASOSE students to showcase their skills and expertise. It is a one-of-its-kind robotics competition conceived to foster innovation and problem-solving among school students. Its aim is to enable students to learn design thinking by conceptualizing game solutions, designing and building robots, testing, debugging, and ultimately creating a winning strategy. The HE21 exhibition (part of DRL event) showcases the students’ creation on the theme of ‘Future Forward’ which reflects solutions to real world problems of the 21st Century. <b>This year’s DRL saw 600 students from HE-21 ASoSEs and different government and private schools of Delhi competing in the finale. HE21 ASOSE students from ASOSE, Rohini Sector 11 emerged victorious against top private schools in Delhi, adding another feather to the ASOSE cap. More details about the DRL can be found
                                                    &nbsp;<a target="_blank" href='https://www.delhiroboticsleague.com/'>here</a></b>
                                                  </p>

                                                  <p>
                                                  
                                                2. <b>Youth Ideathon</b> is a competition conducted by 
                                                <b>Think Startup, CBSE, MEPSC</b> (Management, Entrepreneurship & Professional Skills Council)
                                                <b> Govt. of India, and IIT Delhi</b>. 
                                                Here, students are encouraged to ideate and develop solutions for societal problems. 
                                                <b>At Youth Ideathon, 2023, students of ASOSE Sec-11 Rohini were placed amongst the top 10 teams, winning an incubation amount of Rs. 1,00,000.</b>


                                                  </p>


                                            </div>
                                                
                                          </div>
                                            </div>
                                        </div>

                                    </div>
                                    <br/>

                                </div>
                            </div>
                        )}


                    </div>

                    <div className='horizontal'></div>

          <div className="accordian">
            <div
              className="outer"
              onClick={() => setShowCreators(!showCreators)}
            >
              <div className='title'>Knowledge <span>Partners</span></div>
              <div className="icon">{showCreators ? arrowUp : arrowDown}</div>
            </div>
            {showCreators && (
              <div className="inner">
                <div className="creators_container">
                  <div className="images_container">
                    <img src={IITDelhiLogo} alt="IIT Delhi Logo" />
                    <img src={NIFTLogo} alt="NIFT Logo" />
                    <img src={CampK12Logo} alt="Camp K12 Logo" />
                    <img src={LAHILogo} alt="Lend A Hand Logo" />
                  </div>
                  <div className="content_container">
                    <p>
                      <strong>IIT Delhi: </strong>Indian Institute of Technology, Delhi is one of the Twenty Three IITs created to be Centres of Excellence for training, research and development in science, engineering and technology in India.
                      <br />
                      Website: <a href="https://home.iitd.ac.in/">https://home.iitd.ac.in/</a>
                    </p>
                    <p>
                      <strong>NIFT Delhi: </strong>NIFT is the pioneering institute of fashion education in the country and has been in the vanguard of providing professional human resources to the textile and apparel industry. NIFT has also been working as a knowledge service provider to the Union and State governments in the area of design development and positioning of handlooms and handicrafts.
                      <br />
                      Website:<a href="https://www.nift.ac.in/delhi">https://www.nift.ac.in/delhi</a>
                    </p>
                    <p>
                      <strong>Lend-a-Hand India: </strong>Lend-a-hand India is a non-profit organisation which aims to integrate skill education with mainstream education and prepare youth for employment and entrepreneurship opportunities by working at the intersection of education and livelihood.
                      <br />
                      Website:<a href=" https://lendahandindia.org ">https://lendahandindia.org</a>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="elegibility_criteria_section">
        <div className='map-container'>
          <iframe
            src="https://www.google.com/maps/d/embed?mid=1i3OMqRMxRzkusq4nePX8zQXjCA3gHjY&ehbc=2E312F"
            width="100%"
            height="100%"
            title='List Of ASoSE HE 21 Schools'
          />
        </div>

        <div className="title testinomials_heading">Testimonials</div>
      </div>

      <div className="testimonials_section">
        <Carousel
          showArrows={true}
          autoPlay
          emulateTouch
          swipeable
          stopOnHover
          infiniteLoop
          showStatus={false}
          showThumbs={false}
          showIndicators={false}
        >
          <div className="testimonials_container">
            <div className="image">
              <img src={He21StudentTestimonial} alt="" />
            </div>
            <div className="desc">
              <div className="para">
                “Taking admission in these schools gave me an opportunity to
                learn many useful skills, which will help me make an informed
                decision about which career path to pursue. I learned coding
                here, and I would like to pursue a career in the same field
                which will secure my future."
              </div>
              <div className="name">Student</div>
              <div className="post">ASOSE- HE 21 </div>
            </div>
          </div>
          <div className="testimonials_container">
            <div className="image">
              <img src={He21TeacherTestimonial} alt="" />
            </div>
            <div className="desc">
              <div className="para">
                “What an amazing experience I had with these super creative and
                talented students! From an amazingly supporting school staff and
                incredible students to the availability of well-equipped skill
                labs with the latest and industrial standard technology Ambedkar
                SOSE has everything. And this has helped me in delivering
                practical knowledge of fashion and textile industry which is
                prevalent in the current business arena and prospects.”
              </div>
              <div className="name">Facilitator</div>
              <div className="post">
                Fashion and Aesthetics Facilitator, ASOSE- HE 21
              </div>
            </div>
          </div>
          <div className="testimonials_container">
            <div className="image">
              <img src={He21PartnerTestimonial} alt="" />
            </div>
            <div className="desc">
              <div className="para">
                Ambedkar SOSE is a great initiative. It is preparing children
                for the 21st century skills. Greater focus on early skill
                development will be helpful in career development for children
                who are sure which direction to take in their lives. Digital
                Media and Design has given a great opportunity for me to
                interact with very talented children in the Ambedkar SOSEs. Our
                class atmosphere is very vibrant and there is plenary of
                opportunity for creative people to participate in solution
                finding.
              </div>
              <div className="name">Prof. Jyoti Kumar</div>
              <div className="post"> Department of Design, IIT Delhi</div>
            </div>
          </div>
        </Carousel>
      </div>

     
      <SchoolGallery images={[
        { src: GalleryImg1, width: 250, height: 152 },
        { src: GalleryImg3, width: 250, height: 152 },
        { src: GalleryImg4, width: 250, height: 152 },
        { src: GalleryImg2, width: 250, height: 152 },
        { src: GalleryImg5, width: 250, height: 152 },
      ]} />

    </div>
  );
};

export default HE21;
